import { Icon } from "@mui/material";
import ModalInstallApp from "components/InstallInstructions";
import SoftButton from "components/SoftButton";
import { getDeferredPrompt } from "index"; // o donde lo hayas exportado
import { useEffect, useState } from "react";

const InstallPWA = () => {
  // no usamos aquí supportsPWA, sólo si ya tenemos deferredPrompt
  const [available, setAvailable] = useState(!!getDeferredPrompt());
  const [showInstructions, setShowInstructions] = useState(false);

  useEffect(() => {
    const handler = () => setAvailable(true);
    window.addEventListener("pwa-install-available", handler);
    return () => window.removeEventListener("pwa-install-available", handler);
  }, []);

  const onClick = async (evt) => {
    if (available) {
      evt.preventDefault();
      const promptEvent = getDeferredPrompt();
      if (!promptEvent) {
        // opcional: mostrar snackbar en vez de alert
        return alert("La instalación no está disponible (todavía).");
      }
      promptEvent.prompt();
      const { outcome } = await promptEvent.userChoice;
      console.log(`El usuario ${outcome}`);
      // para no volver a usarlo:
      window.deferredPrompt = null;
      setAvailable(false);
    } else {
      setShowInstructions(true);
    }
  };

  return (
    <>
      <SoftButton
        id="setup_button"
        onClick={onClick}
        size="large"
        color="uproGreen"
        circular
        sx={{
          transition: "background-color 0.3s ease",
          animation: "float 3s ease-in-out infinite",
          "@keyframes float": {
            "0%": { transform: "translateY(0)" },
            "50%": { transform: "translateY(-10px)" },
            "100%": { transform: "translateY(0)" },
          },
        }}
      >
        Instalar APP&nbsp;
        <Icon sx={{ display: { xs: "block", sm: "none" } }}>install_mobile</Icon>
        <Icon sx={{ display: { xs: "none", sm: "block" } }}>install_desktop</Icon>
      </SoftButton>
      <ModalInstallApp open={showInstructions} handleClose={() => setShowInstructions(false)} />
    </>
  );
};

export default InstallPWA;
